<template>
  <div class="comp-ly">
    <div class="icon">
      <router-link
        :to="
          `${$subsitePrefix}/innovation/roadshow-detail/roadshow?id=${data.Id}`
        "
      >
        <img @error="imgError" :src="data.Picture" :alt="data.Headline" />
      </router-link>
    </div>
    <div class="name">{{ data.Summary }}</div>
    <div class="desc">
      <!-- <span>
        <i class="el-icon-view"></i>
        {{ data.view }}
      </span> -->
      <span class="field-left">
        <i class="el-icon-camera"></i>
        {{ data.Type }}
      </span>
      <span class="field-right">
        <i class="el-icon-time"></i>
        {{ formartDate(data.StartTime, "minutes") }}
      </span>
      <!-- el-icon-video-camera -->
      <!-- <span class="play">
        <router-link :to="'/feature/ah/preach/detail/' + data.id">
          <i class="el-icon-video-play"></i>立即观看
        </router-link>
      </span> -->
    </div>
  </div>
</template>

<script>
import tools from "@/mixins/content-tools";
export default {
  name: "ly-card",
  // filters: {
  //   status(val) {
  //     if (new Date().getTime() > new Date(val).getTime()) {//开始
  //       return true
  //     }
  //     return false
  //   }
  // },
  mixins: [tools],
  props: {
    data: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
.comp-ly {
  width: 376px;
  height: 292px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.08);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
  margin-left: 24px;
  .icon {
    width: 376px;
    height: 176px;
    overflow: hidden;
    border-radius: 8px 8px 0 0;
    transition: all 0.3 ease;
  }
  .name {
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
    margin: 20px 24px 10px 24px;
    @include ellipsisc(2);
    height: 44px;
  }
  .desc {
    display: flex;
    justify-content: space-between;
    font-size: 15px;
    margin: 0 24px;
    .field-left {
      color: #999;
      i {
        margin-right: 5px;
      }
    }
    .field-right {
      color: #5cc7cf;
      position: relative;
      &::before {
        width: 4px;
        height: 4px;
        position: absolute;
        content: " ";
        display: inline-block;
        overflow: hidden;
        left: -10px;
        top: 7px;
      }
    }
    i {
      padding-right: 2px;
    }
    .play {
      color: $primary-color;
      cursor: pointer;
      a {
        color: $primary-color;
      }
    }
  }
  &:nth-child(3n-2) {
    margin-left: 0;
  }
  &:hover {
    box-shadow: 0px 4px 12px 0px rgba(69, 80, 238, 0.16);
  }
}
</style>
